import React from 'react';
import { motion } from 'framer-motion';
import Marquee from "react-fast-marquee";

/* ===== Images ===== */
// Assuming all imports are correct based on user's file
import Ares from "../images/Ares.jpeg";
import easecruit from "../images/easecruit.png";
import Bodyloop from "../images/BODYLOOP_LABS.jpg";
import chematico from "../images/chematico.jpeg";
import edith from "../images/edith_health.jpeg";
import epilepto from "../images/epilepto.png";
import evigway from "../images/evigway.jpeg";
import greeninv from "../images/GREEN_INNOVOTECH.jpg";
import jyoma from "../images/JYOMA_SOLUTIONS.jpg";
import logier from "../images/logier.png";
import nanokriti from "../images/nanokriti.png";
import neontram from "../images/Neontram.jpg";
import renao from "../images/renao.jpg";
import rosch from "../images/rosch-crete.jpg";
import scratchnest from "../images/Scratchnest.png";
import yoboshu from "../images/yoboshu.png";
import speedybyte from "../images/speedbyte1.png";
import vanix from "../images/vanix.png";
import citpeels from "../images/Citpeels.png";
import texoedge from "../images/Texoedge.jpg";
import yInstrument from "../images/Y Instrumentation.png";
import Fulectronics from "../images/Fulectronics.webp";
import Huskage from "../images/Huskage.png";
import MedXbid from "../images/MedXbid.png";
import SVIG from "../images/SVIG.webp";
import dronetech from "../images/dronetech.png";
import BEF from "../images/BFP.png";
import agniverse from "../images/agniverse.png";
import agb from "../images/agb solution.jpeg";
import ML from "../images/ML.png";
import DG from "../images/DG.png";

// Consolidated Data List
const startupsList = [
  { img: Ares, name: "Ares" },
  { img: easecruit, name: "EaseCruit" },
  { img: speedybyte, name: "SpeedyByte" },
  { img: Bodyloop, name: "Bodyloop Labs" },
  { img: edith, name: "Edith HealthCare" },
  { img: scratchnest, name: "ScratchNest" },
  { img: vanix, name: "Vanix" },
  { img: yoboshu, name: "Yoboshu" },
  { img: logier, name: "Logier" },
  { img: jyoma, name: "Jyoma" },
  { img: greeninv, name: "Green Inv" },
  { img: neontram, name: "Neontram" },
  { img: nanokriti, name: "NanoKriti" },
  { img: rosch, name: "Rosch" },
  { img: renao, name: "Renao" },
  { img: evigway, name: "Evigway" },
  { img: epilepto, name: "Epilepto" },
  { img: chematico, name: "Chematico" },
  { img: citpeels, name: "CitPeels" },
  { img: texoedge, name: "TexoEdge" },
  { img: yInstrument, name: "Y Instrumentation" },
  { img: Fulectronics, name: "Fulectronix" },
  { img: Huskage, name: "Huskage" },
  { img: MedXbid, name: "MedXbid" },
  { img: SVIG, name: "SVM" },
  { img: dronetech, name: "Drones Tech" },
  { img: BEF, name: "BEF" },
  { img: agniverse, name: "Agniverse" },
  { img: agb, name: "AGB Solutions" },
  { img: ML, name: "ML WorkX" },
  { img: DG, name: "Dg" },
];

const Startups = () => {
  return (
    <div className="bg-slate-50 min-h-screen font-sans text-slate-900 selection:bg-blue-100 selection:text-blue-900">
      
      {/* --- HERO HEADER --- */}
      <div className="bg-slate-900 text-white pt-32 pb-20 px-6 text-center relative overflow-hidden">
         <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-blue-600/10 rounded-full blur-[100px] pointer-events-none"></div>
         <div className="max-w-4xl mx-auto relative z-10">
            <span className="text-blue-400 font-bold uppercase tracking-widest text-xs border border-blue-500/30 px-3 py-1 rounded-full bg-blue-900/20 backdrop-blur-md">
               Portfolio
            </span>
            <h1 className="text-4xl md:text-6xl font-bold mt-6 mb-6">
               Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400">Incubatees</span>
            </h1>
            <p className="text-slate-400 text-lg max-w-2xl mx-auto leading-relaxed">
               Meet the innovative startups transforming industries under the guidance of TBIF IIT Ropar.
            </p>
         </div>
      </div>

      {/* --- SCROLLING TICKER --- */}
      <div className="py-8 bg-white border-b border-slate-200">
        <Marquee speed={40} gradient={true} gradientWidth={50}>
            {startupsList.map((data, i) => (
                <div key={i} className="mx-8 opacity-50 hover:opacity-100 transition-opacity cursor-default">
                    <img src={data.img} alt={data.name} className="h-12 w-auto object-contain grayscale hover:grayscale-0 transition-all" />
                </div>
            ))}
        </Marquee>
      </div>

      {/* --- MAIN GRID --- */}
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-8">
          {startupsList.map((startup, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
              whileHover={{ y: -5 }}
              className="bg-white rounded-xl p-6 shadow-sm hover:shadow-xl border border-slate-100 hover:border-blue-100 transition-all duration-300 flex flex-col items-center justify-center group h-48"
            >
              <div className="h-24 w-full flex items-center justify-center mb-4 overflow-hidden">
                <img
                  src={startup.img}
                  alt={startup.name}
                  className="max-h-full max-w-full object-contain group-hover:scale-110 transition-transform duration-300"
                />
              </div>
              <h3 className="text-sm font-bold text-slate-700 group-hover:text-blue-600 text-center">
                {startup.name}
              </h3>
            </motion.div>
          ))}
        </div>
      </div>

    </div>
  );
};

export default Startups;